import React, { FunctionComponent } from 'react';
import {
  StyleSheet, Switch as RNSwitch, Platform,
} from 'react-native';
import WebSwitch from 'react-switch';
import Theme from '../../theme';
import { defaultScale } from '../../utils';

interface IProps {
  value: boolean;
  onValueChange(value: boolean): void;
}

export const Switch: FunctionComponent<IProps> = (
  {
    value,
    onValueChange,
  },
) => (
  Platform.OS === 'web' ? (
    <WebSwitch
      checked={value}
      onChange={onValueChange}
      onColor={Theme.PRIMARY}
      offColor={Theme.GREY_LIGHT}
      offHandleColor={Theme.WHITE}
      onHandleColor={Theme.WHITE}
      uncheckedIcon={false}
      checkedIcon={false}
      height={defaultScale(17)}
      width={defaultScale(35)}
    />
  ) : (
    <RNSwitch
      trackColor={{ false: Theme.GREY_LIGHT, true: Theme.PRIMARY }}
      thumbColor={Theme.WHITE}
      ios_backgroundColor={Theme.GREY_LIGHT}
      onValueChange={onValueChange}
      value={value}
      style={styles.switch}
    />
  )
);

const styles = StyleSheet.create({
  switch: {
    transform: [{ scaleX: defaultScale(0.8) }, { scaleY: defaultScale(0.8) }],
  },
});
